import React from "react";
import { FileText, FolderPlus, FolderX, ImageIcon } from "lucide-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
interface AppBarProps {
  currentFolderId: string | null;
  onCreateFolder: () => void;
  onDeleteFolder: () => void;
  showNote: () => void;
}
const AppBar: React.FC<AppBarProps> = ({
  currentFolderId,
  onCreateFolder,
  onDeleteFolder,
  showNote
}) => {
  return <div className="flex flex-col sm:flex-row items-start sm:items-center sm:justify-between gap-2 px-4 py-2 bg-slate-950 dark:bg-gray-950 rounded-lg shadow-lg w-full" data-sentry-component="AppBar" data-sentry-source-file="index.tsx">
            <div className="flex flex-wrap items-center gap-2">
                <Button variant="ghost" onClick={onCreateFolder} className="text-gray-200 hover:text-white" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                    <FolderPlus className="w-4 h-4 mr-2" data-sentry-element="FolderPlus" data-sentry-source-file="index.tsx" />
                    New Folder
                </Button>

                <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-source-file="index.tsx">
                    <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="index.tsx">
                        <Button variant="ghost" className="text-gray-200 hover:text-white" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                            <ImageIcon className="w-4 h-4 mr-2" data-sentry-element="ImageIcon" data-sentry-source-file="index.tsx" />
                            New Image
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="start" className="w-48" data-sentry-element="DropdownMenuContent" data-sentry-source-file="index.tsx">
                        <DropdownMenuItem data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                            <Link title="Battlemap Generator" href="/generate?category=battlemaps" data-sentry-element="Link" data-sentry-source-file="index.tsx">
                                Battlemap
                            </Link>
                        </DropdownMenuItem>
                        <DropdownMenuItem data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                            <Link title="Character Generator" href="/generate" data-sentry-element="Link" data-sentry-source-file="index.tsx">
                                Character
                            </Link>
                        </DropdownMenuItem>
                        <DropdownMenuItem data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                            <Link title="Item Generator" href="/generate?category=items" data-sentry-element="Link" data-sentry-source-file="index.tsx">
                                Item
                            </Link>
                        </DropdownMenuItem>
                        <DropdownMenuSeparator data-sentry-element="DropdownMenuSeparator" data-sentry-source-file="index.tsx" />
                        <DropdownMenuItem data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                            <Link title="Landscape Generator" href="/generate?category=landscapes" data-sentry-element="Link" data-sentry-source-file="index.tsx">
                                Landscape
                            </Link>
                        </DropdownMenuItem>
                        <DropdownMenuItem data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                            <Link title="Monster Generator" href="/generate?category=monsters" data-sentry-element="Link" data-sentry-source-file="index.tsx">
                                Monster
                            </Link>
                        </DropdownMenuItem>
                        <DropdownMenuItem data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                            <Link title="NPC Generator" href="/generate?category=npcs" data-sentry-element="Link" data-sentry-source-file="index.tsx">
                                NPC
                            </Link>
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
                <Button variant="ghost" onClick={e => {
        e.stopPropagation();
        showNote();
      }} className="text-gray-200 hover:text-white" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                    <FileText className="w-4 h-4 text-white-500 mr-2" data-sentry-element="FileText" data-sentry-source-file="index.tsx" />
                    <span className="">Show Notes</span>
                </Button>
            </div>

            {currentFolderId && <Button variant="ghost" onClick={onDeleteFolder} className="text-red-400 hover:text-red-300 hover:bg-red-900/20">
                    <FolderX className="w-4 h-4 mr-2" />
                    Delete Folder
                </Button>}
        </div>;
};
export default AppBar;